import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import API_URL from '../constants/environment';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import { Permission, Role, WebsiteTab } from './useValidateSession';

export interface UserPermission {
    permissions: Array<Permission>;
    tabs: Array<WebsiteTab>;
}

export interface EditDefaultPermissionsInput {
    defaultPermissions: Record<Role, UserPermission>;
}

const editDefaultPermissions = async (
    input: EditDefaultPermissionsInput,
    sessionId: string | null
) => {
    return axios.patch(`${API_URL}/settings/permissions/edit`,
        { defaultPermissions: input.defaultPermissions },
        {
            headers: {
                Authorization: sessionId
            }
        }
    );
};

export const useEditDefaultPermissions = () => {
    const sessionContext = useContext(SessionContext);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (input: EditDefaultPermissionsInput) => editDefaultPermissions(input, sessionContext?.sessionId ?? null),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['settings'] });
            queryClient.invalidateQueries({ queryKey: ['/account/validate'] });
        },
    });
};
